"use strict";

var _toConsumableArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateFieldProps = exports.genRowKey = exports.groupFields = exports.removeAuxiliaryFields = exports.userFormMapValues = exports.getFieldNormalizer = exports.getSelectedOptionId = exports.getFieldValidation = exports.hasOptions = exports.filterVisibleOptions = void 0;

var _webUtils = require("@widergy/web-utils");

var _normalize = require("@widergy/web-utils/lib/normalize");

var _array = require("@widergy/web-utils/lib/array");

var _seamlessImmutable = require("seamless-immutable");

var _lodash = _interopRequireDefault(require("lodash"));

var _fallbackMessages = require("../constants/fallbackMessages");

var FIELD_TYPES = _interopRequireWildcard(require("../constants/fieldTypes"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isFieldOptionVisible = function isFieldOptionVisible(fieldOption, selectedOptionsIds) {
  return !fieldOption.parent_field_option_id || selectedOptionsIds.includes(fieldOption.parent_field_option_id);
};

var getInvalidBins = function getInvalidBins(fieldProps, fieldConf) {
  return fieldConf && fieldConf.invalid_bins && Array.isArray(fieldConf.invalid_bins) && Array.isArray(fieldProps.invalidBins) ? [].concat(_toConsumableArray(fieldProps.invalidBins), _toConsumableArray(fieldConf.invalid_bins)) : fieldProps.invalidBins;
};

var filterVisibleOptions = function filterVisibleOptions(field, selectedOptionsIds) {
  return field.field_options.filter(function (option) {
    return isFieldOptionVisible(option, selectedOptionsIds);
  });
};

exports.filterVisibleOptions = filterVisibleOptions;
var FIELDS_WITH_OPTIONS = [FIELD_TYPES.FIELD_RADIO, FIELD_TYPES.FIELD_SELECT];

var hasOptions = function hasOptions(field) {
  return FIELDS_WITH_OPTIONS.indexOf(field.type) !== -1;
};

exports.hasOptions = hasOptions;

var getFieldValidation = function getFieldValidation(field, selectedOptionsIds, keyMap) {
  var defaultMessages = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var fieldProps = arguments.length > 4 ? arguments[4] : undefined;
  var validations = [];

  if (field.required) {
    validations.push(_webUtils.VALIDATE_UTILS.required(field.required_message || (0, _seamlessImmutable.getIn)(defaultMessages, ['required'], _fallbackMessages.FALLBACK_MESSAGES.required)));
  }

  if (field.validate) {
    if (Array.isArray(field.validate)) {
      validations = [].concat(_toConsumableArray(validations), _toConsumableArray(field.validate));
    } else {
      validations.push(field.validate);
    }
  }

  if (field.logic_evaluation && keyMap) {
    validations.push(_webUtils.VALIDATE_UTILS.logicValidation(keyMap, field.logic_evaluation, field.logic_evaluation_error_message || (0, _seamlessImmutable.getIn)(defaultMessages, ['logicValidation'], _fallbackMessages.FALLBACK_MESSAGES.logicValidation), 'id'));
  }

  if (hasOptions(field) && filterVisibleOptions(field, selectedOptionsIds).length === 0) {
    return validations;
  }

  if (field.type === FIELD_TYPES.FIELD_ANIMATED_CREDIT_CARD) {
    var invalidBins = getInvalidBins(fieldProps, field.configuration);
    validations.push(_webUtils.VALIDATE_UTILS.validateAnimatedCreditCard((0, _seamlessImmutable.getIn)(defaultMessages, ['creditCardErrorMessages'], _fallbackMessages.FALLBACK_MESSAGES.creditCardErrorMessages), field.child_keys, invalidBins));
  }

  if (field.type === FIELD_TYPES.FIELD_SKETCH) validations.push(_webUtils.VALIDATE_UTILS.validateSketch((0, _seamlessImmutable.getIn)(defaultMessages, ['sketchErrorMessages'], _fallbackMessages.FALLBACK_MESSAGES.required), field.configuration));

  if (field.type === FIELD_TYPES.FIELD_CREDIT_CARD) {
    validations.push(_webUtils.VALIDATE_UTILS.validateCreditCard((0, _seamlessImmutable.getIn)(defaultMessages, ['invalidCard'], _fallbackMessages.FALLBACK_MESSAGES.invalidCard)));

    var _invalidBins = getInvalidBins(fieldProps, field.configuration);

    if (!(0, _array.isEmpty)(_invalidBins)) {
      validations.push(_webUtils.VALIDATE_UTILS.validateInvalidBins(_invalidBins, field.configuration.error_message || _fallbackMessages.FALLBACK_MESSAGES.invalidCard));
    }
  }

  if (field.type === FIELD_TYPES.FIELD_PHONE) {
    if (field.child_keys) validations.push(_webUtils.VALIDATE_UTILS.validatePhoneWithChildKeys((0, _seamlessImmutable.getIn)(defaultMessages, ['invalidFormat'], _fallbackMessages.FALLBACK_MESSAGES.invalidFormat)));else validations.push(_webUtils.VALIDATE_UTILS.lengthEquals(10, (0, _seamlessImmutable.getIn)(defaultMessages, ['invalidFormat'], _fallbackMessages.FALLBACK_MESSAGES.invalidFormat), true));
  }

  if (field.type === FIELD_TYPES.FIELD_EMAIL) {
    validations.push(_webUtils.VALIDATE_UTILS.email((0, _seamlessImmutable.getIn)(defaultMessages, ['invalidEmail'], _fallbackMessages.FALLBACK_MESSAGES.invalidEmail)));
  }

  if (field.type === FIELD_TYPES.FIELD_DATE) {
    if (field.configuration && field.configuration.monthYearFormat) {
      validations.push(_webUtils.VALIDATE_UTILS.validDateCreditCard((0, _seamlessImmutable.getIn)(defaultMessages, ['invalidDate'], _fallbackMessages.FALLBACK_MESSAGES.invalidDate)));
    } else {
      validations.push(_webUtils.VALIDATE_UTILS.validDate((0, _seamlessImmutable.getIn)(defaultMessages, ['invalidDate'], _fallbackMessages.FALLBACK_MESSAGES.invalidDate)));
    }
  }

  if (field.format) {
    var errorMessage = field.format_error_message || (0, _seamlessImmutable.getIn)(defaultMessages, ['invalidFormat'], _fallbackMessages.FALLBACK_MESSAGES.invalidFormat);
    validations.push(_webUtils.VALIDATE_UTILS.pattern(new RegExp(field.format), errorMessage));
  }

  if (fieldProps && fieldProps.validate) {
    if (Array.isArray(fieldProps.validate)) {
      validations = [].concat(_toConsumableArray(validations), _toConsumableArray(fieldProps.validate));
    } else {
      validations.push(fieldProps.validate);
    }
  }

  return validations;
};

exports.getFieldValidation = getFieldValidation;

var getSelectedOptionId = function getSelectedOptionId(fields, key, option) {
  var selectedField = fields.find(function (field) {
    return field.key === key;
  });
  return selectedField.field_options && selectedField.field_options.find(function (item) {
    return item.name === option && item.id;
  });
};

exports.getSelectedOptionId = getSelectedOptionId;

var getFieldNormalizer = function getFieldNormalizer(field) {
  var normalize = [];

  if (field.normalize) {
    if (Array.isArray(field.normalize)) {
      normalize = _toConsumableArray(field.normalize);
    } else {
      normalize.push(field.normalize);
    }
  }

  if (field.type === FIELD_TYPES.FIELD_CREDIT_CARD) {
    normalize.push((0, _normalize.numberMaxLength)(16));
  }

  if (field.type === FIELD_TYPES.FIELD_DATE) {
    if (field.configuration && field.configuration.monthYearFormat) {
      normalize.push(_normalize.formatExpirationDate);
    } else {
      normalize.push(_normalize.normalizeDate);
    }
  }

  return (0, _normalize.normalizeAll)(normalize);
};

exports.getFieldNormalizer = getFieldNormalizer;

var userFormMapValues = function userFormMapValues(values, fields) {
  var fieldNames = Object.keys(values);
  var newValues = {};
  var formData = {};

  var _loop = function _loop(i) {
    var field = fields.find(function (element) {
      return element.id.toString() === fieldNames[i].substring(2);
    });

    if (field) {
      newValues[field.key] = values[fieldNames[i]];
      formData[field.key] = field.type;
    }
  };

  for (var i = 0; i < fieldNames.length; i += 1) {
    _loop(i);
  }

  return {
    newValues: newValues,
    formData: formData
  };
};

exports.userFormMapValues = userFormMapValues;

var removeAuxiliaryFields = function removeAuxiliaryFields(fields) {
  return fields.filter(function (field) {
    return !field.auxiliary;
  });
};

exports.removeAuxiliaryFields = removeAuxiliaryFields;

var existsFieldWithoutOrder = function existsFieldWithoutOrder(fields) {
  return fields.some(function (field) {
    return !field.order && field.order !== 0;
  });
};

var groupFields = function groupFields(fields, formVisibility, ignoreVisibility) {
  if (!(0, _array.isEmpty)(fields)) {
    var newFields = [];
    var visibleFields = ignoreVisibility ? fields : fields.filter(function (field) {
      return formVisibility.isFieldVisible(field);
    });

    if (existsFieldWithoutOrder(fields)) {
      visibleFields.forEach(function (field) {
        return newFields.push([field]);
      });
      return newFields;
    }

    var sortedFields = _toConsumableArray(visibleFields).sort(function (a, b) {
      return a.order - b.order;
    });

    var fieldRowOrder;

    for (var index = 0; index < sortedFields.length; index += 1) {
      if (sortedFields[index].order === fieldRowOrder) {
        newFields[fieldRowOrder].push(sortedFields[index]);
      } else {
        fieldRowOrder = sortedFields[index].order;
        newFields[fieldRowOrder] = [];
        newFields[fieldRowOrder].push(sortedFields[index]);
      }
    }

    newFields = newFields.filter(function (element) {
      return element !== null;
    });
    newFields = newFields.map(function (fieldRow) {
      return fieldRow.sort(function (fieldA, fieldB) {
        return fieldA.suborder - fieldB.suborder;
      });
    });
    return newFields;
  }

  return [];
};

exports.groupFields = groupFields;

var genRowKey = function genRowKey(row) {
  var key;

  if (!(0, _array.isEmpty)(row) && row[0].order) {
    key = "row_".concat(row[0].order);
  } else {
    key = row.reduce(function (acum, actualElement) {
      return "".concat(acum, "_").concat(actualElement.key);
    }, 'row');
  }

  return key;
};

exports.genRowKey = genRowKey;

var generateFieldProps = function generateFieldProps() {
  var fieldTypeProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var selectedOptionsIds = arguments.length > 1 ? arguments[1] : undefined;
  var account = arguments.length > 2 ? arguments[2] : undefined;

  var fieldProps = _lodash.default.clone(fieldTypeProps, true);

  Object.values(FIELD_TYPES).forEach(function (key) {
    return fieldProps[key] = Object.assign(fieldProps[key] || {}, {
      account: account,
      selectedOptionsIds: selectedOptionsIds
    });
  });
  return fieldProps;
};

exports.generateFieldProps = generateFieldProps;